"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStaticComponentsLoaders = void 0;
function createStaticComponentsLoaders(dictionary, info, manifest, batch) {
    if (!dictionary) {
        return {};
    }
    var components = {};
    Object.keys(dictionary).forEach(function (componentName) {
        var loader = function () {
            return Promise.resolve(dictionary[componentName]);
        };
        var assets = manifest.components[componentName]
            ? manifest.components[componentName].assets
            : [];
        /**
         * set within which batch bundle component was loaded
         * currently, this is the only way to do this
         *
         * Why is this needed? – for SSR cases
         *
         * - we should inline all used component to the head
         * - we inline batch bundle
         * - we we should understand, which components are included to the bundle,
         * so we can inline all used components and filter which are included to the batch
         *
         * NOTE this is temporary solution,
         * in future should be resolved with the new registry manifest structure
         */
        loader.assets = !batch
            ? assets
            : assets.map(function (asset) { return (__assign(__assign({}, asset), { batch: batch })); });
        loader.isPartExist = function () {
            console.warn("Registry Warning \u2013 \"isPartExist\" is not valid for \"eager\" registry. Probably there is redundant call.");
            return false;
        };
        if (info[componentName]) {
            loader.info = info[componentName];
        }
        components[componentName] = loader;
    });
    return components;
}
exports.createStaticComponentsLoaders = createStaticComponentsLoaders;
//# sourceMappingURL=createStaticComponentsLoaders.js.map